import SvgSymbol from './SvgSymbol';
export default SvgSymbol;
